import React from "react";
import { makeStyles } from "@material-ui/core";
import { Box } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  permission: {
    textAlign: "center",
    marginTop: 30,
  },
}));

const NoOrganizations = () => {
  const classes = useStyles();
  return (
    <Box className={classes.permission}>
      This user does not have reporting permissions.
    </Box>
  );
};

export default NoOrganizations;
